import { Box } from '@scope/scope-one-ui/core';
import styled from 'styled-components';

export const Legend = styled(Box)`
  svg {
    flex-shrink: 0;
  }

  max-width: min-content;
`;
